import { useMemo, useSyncExternalStore } from 'react'

import { getSnapshot, subscribe } from './remoteConfigStore.js'

function identity(value) {
  return value
}

export function useRemoteConfigStore(selector = identity) {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
  return selector(snapshot)
}

export function useRemoteConfigAppState(applicationId) {
  return useRemoteConfigStore((state) => state.applications?.[applicationId] || null)
}

export function useRemoteConfigMemo(fn, deps) {
  // Small helper to keep selectors cheap in components.
  return useMemo(fn, deps)
}

